import React, { useState, useEffect, useMemo, useCallback } from 'react'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { withStyles } from '@material-ui/core'
import EnhancedTable from '../../../../../../../Components/EnhancedTable'
import SequencesControlButtons from '../ControlButtonsSection/SequencesControlButtons'
import {
  headersSequence,
  optionsStages,
  stagesMapper,
  communicationsOptions,
  sequencesSourceOptions,
  sequencesTypeOptions,
} from '../../options'
import { InfoIcon, EditIcon, InboxIcon, DeleteIcon } from './Components/icons'
import { authorization } from '../../../../../../../Module/Auth/Auth'
import Select from '../Select'
import useGraphQLFetch from '../../../../../../../Utils/Hooks/useGraphQLFetch'
import { styles } from './styles'
import LoadingIndicator from '../../../../../../../Components/LoadingIndicator/LoadingIndicator'
import {
  findPipeline,
  editSequence,
  deletePipeline,
  sequenceCount,
  findIfHasStats,
} from '../../gql'
import { PATHS } from 'Config/Routing/paths'
import { useDuplicateSequence } from '../../hooks/useDuplicateSequence'
import { useDuplicateSequenceForCities } from '../../hooks/useDuplicateSequenceForCities'
import { RowOptions } from './Components/RowOptions'
import { SequenceStatusToggle } from './Components/SequenceStatusToggle'
import { CommunicationTypes } from './Components/CommucationTypes'
import { CommunicationsLength } from './Components/CommunicationsLength'
import { SequenceCommsTable } from './Components/SequenceCommsTable'
import { filterAndSortSequences } from '../../utils'
import { isArray } from 'lodash'
import { DATE_SEQUENCE_STATUS } from '../../constants'
import { GenericModal } from './Components/GenericModal'
import TableCell from '@material-ui/core/TableCell'
import Checkbox from '@material-ui/core/Checkbox'
import { useBulkArchiveSequence } from '../../hooks/useBulkArchiveSequence'

const SequenceView = ({
  classes,
  communicationsType,
  pipelineStage,
  handleCommunicationsType,
  handleSequencesType,
  handleSequencesSource,
  handlePipelineStageChange,
  cityId,
  cityName,
  countryName,
  countryId,
  url,
  cityTimezone,
  sequencesType,
  sequencesSource,
  selectedRows,
  setSelectedRows,
  isOnsiteTrainingEnabled,
}) => {
  const { onDuplicateSequence } = useDuplicateSequence({
    cityId,
    cityName,
    countryName,
  })

  const { onDuplicateSequenceForCities } = useDuplicateSequenceForCities({
    originalCityId: cityId,
    cityName,
    countryName,
    countryId,
  })

  const user = useMemo(() => authorization.getUser(), [])
  const history = useHistory()
  const [seqStatus, setSeqStatus] = useState('ACTIVE')
  const [page, setPage] = useState(0)
  const [sequences, setSequences] = useState([])
  const [resultPerPage, setResultPerPage] = useState(25)
  const [isLoadingSequences, setIsLoadingSequences] = useState(true)
  const [totalActiveSequences, setTotalActiveSequences] = useState(undefined)
  const [totalArchivedSequences, setTotalArchivedSequences] = useState(
    undefined,
  )
  const [error, setError] = useState(false)

  const isHardcodedFilterSet = sequencesSource === 'hardcoded'

  const onChangePage = page => setPage(page)

  const onChangeRowsPerPage = value => {
    setResultPerPage(value)
    setPage(0)
  }

  const onSelectRow = useCallback(
    (ids, checked) => {
      setSelectedRows(prevSelected => {
        const newSelected = { ...prevSelected }
        ids.forEach(id => {
          if (checked) {
            newSelected[id] = true
          } else {
            delete newSelected[id]
          }
        })
        return newSelected
      })
    },
    [setSelectedRows],
  )

  const handleStageChange = stage => {
    handlePipelineStageChange(stage)
    setIsLoadingSequences(true)
    onRefetchSequences({ stageName: stage })
  }

  const handleSequenceSourceChange = value => {
    handleSequencesSource(value)
    if (value === 'hardcoded') {
      handleSequencesType('all')
    }
  }

  const onRefetchSequences = ({ stageName }) => {
    refetchSequences({
      cityId,
      stageName,
      status: seqStatus,
      stats: true,
    })

    onSelectRow(
      rows.filter(r => r.params.editable).map(r => r.params.id),
      false,
    )
  }

  const handleSequenceArchive = async seqId => {
    setIsLoadingSequences(true)
    if (seqStatus === 'ACTIVE') {
      await editSequence({ id: seqId, status: 'ARCHIVED' })
      setTotalActiveSequences(prev => prev - 1)
      setTotalArchivedSequences(prev => prev + 1)
    } else {
      await editSequence({ id: seqId, status: 'ACTIVE' })
      setTotalArchivedSequences(prev => prev - 1)
      setTotalActiveSequences(prev => prev + 1)
    }
    onRefetchSequences({ stageName: pipelineStage })
  }

  const handleSequenceDelete = async seqId => {
    setIsLoadingSequences(true)
    const data = await findIfHasStats({ sequenceId: seqId }).then(res =>
      res.json(),
    )
    const {
      data: { sequenceIdHasStats },
    } = data

    if (sequenceIdHasStats) {
      setError(true)
      setIsLoadingSequences(false)
      return
    } else {
      await deletePipeline({ id: seqId })
      if (seqStatus === 'ACTIVE') {
        setTotalActiveSequences(prev => prev - 1)
      } else {
        setTotalArchivedSequences(prev => prev - 1)
      }
      onRefetchSequences({ stageName: pipelineStage })
    }
  }

  const handleEditSequence = seqId => {
    history.push(
      url + PATHS.cities.ambassadorsEmails + '/' + seqId + PATHS.cities.edit,
      { seqStatus },
    )
  }

  const handleEnrollmentsRedirect = seqId => {
    history.push(
      url + PATHS.cities.ambassadorsEmails + '/' + seqId + PATHS.cities.stats,
    )
  }

  const createRowsSequence = data =>
    data.map(row => {
      const { open, clicks, sent } = row.Stats
      const openCount = Number(open)
      const clicksCount = Number(clicks)
      const sentCount = Number(sent)

      const openRate =
        !openCount && !sentCount
          ? '0.00%'
          : String(
              ((openCount / sentCount) * 100).toFixed(2) > 100
                ? 100
                : ((openCount / sentCount) * 100).toFixed(2),
            ) + '%'
      const clicksRate =
        !clicksCount && !openCount
          ? '0.00%'
          : String(
              ((clicksCount / openCount) * 100).toFixed(2) > 100
                ? 100
                : ((clicksCount / openCount) * 100).toFixed(2),
            ) + '%'
      const totalComms = row.Action ? row.Action.length : 0
      return {
        params: {
          selected: !!selectedRows[row.id],
          scheduleDriven:
            isArray(row.DateSequenceTemplate) &&
            row.DateSequenceTemplate.length > 0,
          triggerDriven: isArray(row.Trigger) && row.Trigger.length > 0,
          disabled:
            isArray(row.DateSequenceTemplate) &&
            row.DateSequenceTemplate.length > 0
              ? row.DateSequenceTemplate.some(
                  template =>
                    template.dateSequenceStatus.event ===
                    DATE_SEQUENCE_STATUS.ENDED,
                )
              : false,
          highLight: null,
          id: row.id,
          disableClick: ['options'],
          expandRow: false,
          actionsRaw: row.Action,
          stageRaw: row.stage,
          editable: row.editable || false,
          collapsableInfo: (
            <SequenceCommsTable
              dateSequenceTemplate={
                row.DateSequenceTemplate.length > 0
                  ? row.DateSequenceTemplate[0]
                  : undefined
              }
              communications={row.Action || []}
              sequenceId={row.id}
              hasHardcodedComms={!row.editable}
              sequenceName={row.name}
              trigger={row.Trigger.length ? row.Trigger[0] : undefined}
              cityId={cityId}
            />
          ),
        },
        row: {
          date: `${moment(Number(row.created_at)).format('DD/MM/YYYY')}`,
          owner: row.owner,
          nameSequence: row.name,
          stage: stagesMapper.get(row.stage) || '-',
          numOfComms: totalComms,
          typeOfComms: (
            <CommunicationTypes
              isDateSequence={row.DateSequenceTemplate.length > 0}
              communications={row.Action || []}
            />
          ),
          seqLength: (
            <CommunicationsLength
              communications={row.Action || []}
              trigger={row.Trigger.length ? row.Trigger[0] : undefined}
            />
          ),
          sentCount: sent,
          openCount: open,
          clickCount: clicks,
          openRate: openRate,
          clickRate: clicksRate,
          options: row.editable ? (
            <RowOptions
              rowId={row.id}
              rowPopupOptions={[
                {
                  func: handleEnrollmentsRedirect,
                  Icon: InfoIcon,
                  text: 'Enrollments',
                },
                {
                  func: handleSequenceArchive,
                  Icon: InboxIcon,
                  text: seqStatus == 'ACTIVE' ? 'Archive' : 'Unarchive',
                },
                {
                  func: handleEditSequence,
                  Icon: EditIcon,
                  text: 'Edit',
                },
                {
                  func: handleSequenceDelete,
                  Icon: DeleteIcon,
                  text: 'Delete',
                },
              ]}
            />
          ) : (
            ''
          ),
        },
      }
    })

  const onClickCreateSequence = async () => {
    history.push(url + PATHS.cities.ambassadorsEmailsCreate)
  }

  const handleRowClick = (e, seqId) => {
    const sequence = sequences.find(s => s.params.id === seqId)
    const newSequence = {
      ...sequence,
      params: { ...sequence.params, expandRow: !sequence.params.expandRow },
    }
    const newSequences = sequences.map(seq => {
      if (seq.params.id === seqId) {
        return newSequence
      }
      return seq
    })
    setSequences(newSequences)
  }

  const {
    data: sequencesData,
    isLoaded: isSequencesLoaded,
    refetch: refetchSequences,
  } = useGraphQLFetch({
    fetchFn: findPipeline,
    mapResponse: data => {
      if (!data.hasOwnProperty('findPipeline')) {
        return []
      }

      // Set time zone to DateSequenceTemplate start date
      const parsedData = JSON.parse(data.findPipeline)

      return parsedData
    },
    defaultFetchArgs: {
      cityId,
      stageName: pipelineStage,
      status: seqStatus,
      stats: true,
    },
  })

  const {
    data: totalSequencesData,
    isLoaded: isTotalSequencesLoaded,
    refetch: refetchTotalSequences,
  } = useGraphQLFetch({
    fetchFn: sequenceCount,
    defaultFetchArgs: {
      cityId,
    },
  })

  useEffect(() => {
    if (cityTimezone && isSequencesLoaded) {
      if (sequencesData) {
        const mappedSequences = sequencesData.map(sequence => {
          if (
            sequence.DateSequenceTemplate &&
            sequence.DateSequenceTemplate.length
          ) {
            sequence.DateSequenceTemplate = sequence.DateSequenceTemplate.map(
              dateSequenceTemplate => {
                if (dateSequenceTemplate.start_date) {
                  dateSequenceTemplate.start_date = moment
                    .utc(Number(dateSequenceTemplate.start_date))
                    .tz(cityTimezone)
                    .format('YYYY-MM-DD HH:mm:ss')
                }
                return dateSequenceTemplate
              },
            )
          }

          return sequence
        })

        setSequences(createRowsSequence(mappedSequences))
      }
      setIsLoadingSequences(false)
    }
  }, [isSequencesLoaded, cityTimezone, selectedRows])

  useEffect(() => {
    if (isTotalSequencesLoaded) {
      if (
        totalSequencesData &&
        totalSequencesData.hasOwnProperty('sequenceCount')
      ) {
        setTotalActiveSequences(
          JSON.parse(totalSequencesData.sequenceCount.active),
        )
        setTotalArchivedSequences(
          JSON.parse(totalSequencesData.sequenceCount.archived),
        )
      }
      setIsLoadingSequences(false)
    }
  }, [isTotalSequencesLoaded])

  useEffect(() => {
    if (!isLoadingSequences) {
      setIsLoadingSequences(true)
      refetchTotalSequences({ cityId })
      onRefetchSequences({ stageName: pipelineStage })
    }
  }, [pipelineStage, seqStatus])

  const { totalRows, rows } = filterAndSortSequences(
    sequences,
    communicationsType,
    sequencesType,
    sequencesSource,
    resultPerPage,
    page,
  )

  const allSelected = useMemo(() => {
    const editable = rows.filter(r => r.params.editable)
    if (editable.length === 0) {
      return false
    }
    return (
      editable.map(r => r.params.id).length === Object.keys(selectedRows).length
    )
  }, [selectedRows, rows])

  const rowPrefixComponent = useCallback(
    (id, editable, selected) => (
      <TableCell key={`checkbox-${id}`}>
        {editable && (
          <Checkbox
            checked={selected}
            onChange={(ev, checked) => onSelectRow([id], checked)}
          />
        )}
      </TableCell>
    ),
    [],
  )

  const headerPrefixComponent = useCallback(
    () => (
      <TableCell>
        <Checkbox
          checked={allSelected}
          onChange={(ev, checked) =>
            onSelectRow(
              rows.filter(r => r.params.editable).map(r => r.params.id),
              checked,
            )
          }
        />
      </TableCell>
    ),
    [allSelected, rows],
  )

  const onBulkArchiveFinish = sequencesICount => {
    setIsLoadingSequences(true)
    setTotalActiveSequences(prev => prev - sequencesICount)
    setTotalArchivedSequences(prev => prev + sequencesICount)
    onRefetchSequences({ stageName: pipelineStage })
  }
  const getSequenceById = id => {
    return sequencesData.find(s => s.id == id)
  }
  const { onBulkArchiveSequences } = useBulkArchiveSequence({
    getSequenceById,
    onFinish: onBulkArchiveFinish,
  })

  return (
    <div>
      <SequenceStatusToggle
        seqStatus={seqStatus}
        setSeqStatus={setSeqStatus}
        totalActive={totalActiveSequences}
        totalArchived={totalArchivedSequences}
      />
      <div>
        <SequencesControlButtons
          userRole={user.role}
          onDuplicateSequence={onDuplicateSequence}
          onDuplicateSequenceForCities={onDuplicateSequenceForCities}
          onBulkArchive={onBulkArchiveSequences}
          selectedRows={selectedRows}
          seqStatus={seqStatus}
          onClickCreateSequence={onClickCreateSequence}
          pipelineStage={pipelineStage}
        />

        <div className={classes.selectWrap}>
          <Select
            label="Pipeline sequence type"
            value={sequencesType}
            options={sequencesTypeOptions}
            onChange={handleSequencesType}
            disabled={isHardcodedFilterSet}
            column
          />
          <Select
            label="Stage"
            value={pipelineStage}
            options={optionsStages.filter(option =>
              !isOnsiteTrainingEnabled
                ? option.value !== 'onSiteTraining'
                : true,
            )}
            onChange={handleStageChange}
            column
          />
          <Select
            label="Communications"
            value={communicationsType}
            options={communicationsOptions}
            onChange={handleCommunicationsType}
            column
          />
          <Select
            label="Sequence source"
            value={sequencesSource}
            options={sequencesSourceOptions}
            onChange={handleSequenceSourceChange}
            column
          />
        </div>
        {isLoadingSequences ? (
          <LoadingIndicator style={{ height: '50vh' }} />
        ) : (
          <div className={classes.tableWrapper}>
            <EnhancedTable
              headers={headersSequence}
              rows={rows}
              resultPerPage={resultPerPage}
              onChangePage={onChangePage}
              totalCount={totalRows}
              onChangeRowsPerPage={onChangeRowsPerPage}
              onClickRow={handleRowClick}
              page={page}
              rowsPerPageOptions={[10, 25, 50]}
              rowPrefixComponent={rowPrefixComponent}
              headerPrefixComponent={headerPrefixComponent}
              noDataMessage="There are no sequences for the selected filters"
            />
          </div>
        )}
      </div>
      {error && (
        <GenericModal
          onClose={() => setError(false)}
          title="Cannot erase sequence"
          message="This sequence cannot be erased because some of its communications have been sent. If you want to disable it, you can archive it."
        />
      )}
    </div>
  )
}

export default withStyles(styles)(SequenceView)
